import React from 'react';

import {
  styled,
  Chip,
  Theme
} from '@mui/material';

import { OverallOrderStatusName } from 'generated/graphql';



const OrderStatusChipLarge = styled(Chip, {
  shouldForwardProp: p => p !== 'statusName'
})<{
  statusName: OverallOrderStatusName;
}>(({ theme, statusName }) => ({
  height: 40,
  borderRadius: 20,
  paddingLeft: 55,
  paddingRight: 55,
  color: theme.palette.getContrastText(__getChipBackgroundColor(theme, statusName)),
  backgroundColor: __getChipBackgroundColor(theme, statusName)
}));

const OrderStatusChipNormal = styled(Chip, {
  shouldForwardProp: p => p !== 'statusName'
})<{
  statusName: OverallOrderStatusName;
}>(({ theme, statusName }) => ({
  color: theme.palette.getContrastText(__getChipBackgroundColor(theme, statusName)),
  backgroundColor: __getChipBackgroundColor(theme, statusName)
}));



function __getChipBackgroundColor(theme: Theme, statusName: OverallOrderStatusName) {
  const orderStatusName2BackgroundColor: Record<OverallOrderStatusName, string> = {
    cancelled: theme.palette.error.light,
    completed: theme.palette.primary.main,
    open: theme.palette.grey[100],
    processing: __lightenColor(theme, theme.palette.primary.main, 2)
  };
  return orderStatusName2BackgroundColor[statusName];
}



function __lightenColor(theme: Theme, color: string, times: number): string {
  if (times > 0) {
    const light = theme.palette.augmentColor({
      color: {
        main: color
      }
    }).light;

    return __lightenColor(theme, light, times - 1);
  }

  return color;
}



export interface IProps {
  large?: boolean;
  statusName: OverallOrderStatusName;
  label: string;
}

export const FC: React.FC<IProps> = props => {
  return props.large ? (
    <OrderStatusChipLarge
      label={props.label}
      statusName={props.statusName} />
  ) : (
    <OrderStatusChipNormal
      label={props.label}
      statusName={props.statusName} />
  );
};
